// extracted by mini-css-extract-plugin
export default {"logoutBtn":"dashboard_logoutBtn__S+VDe","dashboardPage":"dashboard_dashboardPage__A1mOs"};